import type { HousekeepingRoomStatus } from '../../../pages/housekeeping/types/housekeeping';
import Button from '../../components/Button';
import Text from '../../components/Text';
import { emplacementChambre, libelleStatut, libelleType } from '../../helpers/menage';
import { t } from '../../i18n/langue';

/**
 * Une chambre à contrôler : « Valider » (ménage terminé) ou « Contrôlée »
 * (chambre propre recontrôlée), et « Refuser » qui la renvoie en ménage.
 */
interface CarteControleProps {
    chambre: HousekeepingRoomStatus;
    occupe: boolean;
    onValider: () => void;
    onRefuser: () => void;
}

export default function CarteControle({ chambre, occupe, onValider, onRefuser }: CarteControleProps) {
    const details = [emplacementChambre(chambre), libelleType(chambre.cleaning_type), libelleStatut(chambre.status)]
        .filter(Boolean)
        .join(' · ');

    return (
        <div className="flex flex-col gap-3 rounded-xl bg-white px-4 py-3">
            <div className="min-w-0">
                <Text variante="sousTitre" as="span" className="block truncate">
                    {chambre.room_name}
                </Text>
                <Text variante="petit" ton="attenue" as="span" className="block truncate">
                    {details}
                </Text>
            </div>
            <div className="grid grid-cols-2 gap-2">
                <Button
                    libelle={chambre.status === 'free_clean' ? t('controles.carte.controlee') : t('controles.carte.valider')}
                    disabled={occupe}
                    onPress={onValider}
                />
                <Button libelle={t('controles.carte.refuser')} variante="secondaire" disabled={occupe} onPress={onRefuser} />
            </div>
        </div>
    );
}
